const listAttributes = ['value', 'label', 'users', 'groups', 'isAccessEditable'] as const;

const getAttributes = [...listAttributes] as const;

const updateAttributes = ['label'] as const;

export const PermissionAttributes = {
  List: listAttributes,
  Get: getAttributes,
  Update: updateAttributes,
};
